var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_370_31493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 0C12.4798 0 12.7198 0.24 12.7198 0.72V4.08C12.7198 4.56 12.4798 4.8 11.9998 4.8C11.5198 4.8 11.2798 4.56 11.2798 4.08V0.72C11.2798 0.24 11.5198 0 11.9998 0Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M4.91176 2.31708C5.2989 2.03332 5.63435 2.08501 5.91812 2.47215L7.90444 5.18215C8.1882 5.5693 8.13651 5.90475 7.74937 6.18851C7.36223 6.47227 7.02678 6.42058 6.74301 6.03344L4.75669 3.32344C4.47293 2.93629 4.52462 2.60084 4.91176 2.31708Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0.637966 8.22934C0.79186 7.77468 1.09614 7.6243 1.5508 7.77819L4.73343 8.85545C5.18809 9.00935 5.33847 9.31363 5.18458 9.76829C5.03068 10.2229 4.7264 10.3733 4.27174 10.2194L1.08912 9.14218C0.634455 8.98828 0.484072 8.68401 0.637966 8.22934Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.06773 14.8826L4.25576 13.8214C4.7112 13.6698 5.01471 13.8218 5.1663 14.2772C5.31789 14.7326 5.16597 15.0361 4.71054 15.1877L1.5225 16.2489C1.06706 16.4005 0.763552 16.2485 0.611961 15.7931C0.460369 15.3377 0.612291 15.0342 1.06773 14.8826Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.7562 20.6762L6.74253 17.9662C7.02629 17.5791 7.36174 17.5274 7.74888 17.8111C8.13603 18.0949 8.18772 18.4303 7.90395 18.8175L5.91763 21.5275C5.63387 21.9146 5.29841 21.9663 4.91127 21.6826C4.52413 21.3988 4.47244 21.0633 4.7562 20.6762Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.9998 19.2C12.4798 19.2 12.7198 19.44 12.7198 19.92V23.28C12.7198 23.76 12.4798 24 11.9998 24C11.5198 24 11.2798 23.76 11.2798 23.28V19.92C11.2798 19.44 11.5198 19.2 11.9998 19.2Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M16.2506 17.8122C16.6378 17.5284 16.9732 17.5801 17.257 17.9672L19.2433 20.6772C19.5271 21.0644 19.4754 21.3998 19.0882 21.6836C18.7011 21.9674 18.3656 21.9157 18.0819 21.5285L16.0956 18.8185C15.8118 18.4314 15.8635 18.0959 16.2506 17.8122Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M18.8327 14.2759C18.9843 13.8204 19.2878 13.6685 19.7432 13.8201L22.9312 14.8812C23.3867 15.0328 23.5386 15.3363 23.387 15.7918C23.2354 16.2472 22.9319 16.3991 22.4765 16.2475L19.2884 15.1864C18.833 15.0348 18.6811 14.7313 18.8327 14.2759Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M19.2889 8.8136L22.477 7.75246C22.9324 7.60087 23.2359 7.75279 23.3875 8.20823C23.5391 8.66366 23.3872 8.96717 22.9317 9.11877L19.7437 10.1799C19.2883 10.3315 18.9847 10.1796 18.8332 9.72414C18.6816 9.2687 18.8335 8.96519 19.2889 8.8136Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M16.0965 5.1806L18.0829 2.4706C18.3666 2.08345 18.7021 2.03176 19.0892 2.31552C19.4764 2.59929 19.528 2.93474 19.2443 3.32188L17.258 6.03188C16.9742 6.41902 16.6387 6.47071 16.2516 6.18695C15.8645 5.90319 15.8128 5.56774 16.0965 5.1806Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 0C12.4798 0 12.7198 0.24 12.7198 0.72V4.08C12.7198 4.56 12.4798 4.8 11.9998 4.8C11.5198 4.8 11.2798 4.56 11.2798 4.08V0.72C11.2798 0.24 11.5198 0 11.9998 0Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_370_31493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.b7f0868ed51d599314dc244b8bc54558.svg";
export { ForwardRef as ReactComponent };